import { render, staticRenderFns } from "./RiskProblemList.vue?vue&type=template&id=5039b2e8&scoped=true"
import script from "./RiskProblemList.vue?vue&type=script&lang=js"
export * from "./RiskProblemList.vue?vue&type=script&lang=js"
import style0 from "./RiskProblemList.vue?vue&type=style&index=0&id=5039b2e8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5039b2e8",
  null
  
)

export default component.exports